import createAction from 'redux-actions/lib/createAction';

export const SET_RENDER_MODE = 'renderActions/SET_RENDER_MODE';

export const setRenderMode = createAction(SET_RENDER_MODE);
